import { isPast, isFuture } from "date-fns";
import data from "../../.sourceflow/events.json";
import CollectionHelper from "@/helpers/CollectionHelper";

class EventsCollectionHelper extends CollectionHelper {
  search(query, locale = "en") {
    return this.filter((e) => e[`title_${locale}`].toLowerCase().includes(query.toLowerCase()));
  }

  fetchUpcomingEvents({ tag = "", query = "" }) {
    return this.search(query)
      .filter((e) => (tag && "tags" in e ? e.tags.includes(tag) : true))
      .filter((e) => isFuture(new Date(e.date)));
  }

  fetchPastEvents({ tag = "", query = "", locale = "en" }) {
    return this.search(query, locale)
      .filter((e) => (tag && "tags" in e ? e.tags.includes(tag) : true))
      .filter((e) => isPast(new Date(e.date)));
  }

  fetchSimilar(event) {
    const event_tags = Array.isArray(event[`tags`]) ? event[`tags`] : [event[`tags`]];

    return this.fetch({
      limit: 5,
      filter: (e) => {
        const e_tags = Array.isArray(e[`tags`]) ? e[`tags`] : [e[`tags`]];

        return e.id !== event.id && event_tags.some((t) => e_tags.includes(t));
      },
    });
  }

  isPastEvent(event) {
    return isPast(new Date(event.date));
  }

  fetchTags() {
    return data.schema.find((s) => s.name === `Tags`).dropdown_values;
  }
}

export const events_helper = new EventsCollectionHelper(data);
